import { GetPrInputListRequest, PatchPrInputRequest, PRInputListItem } from '@finance-lab/utils/types'
import ApiBase from './Api'

const PR_INPUTS_API_PATHS = {
    PR_INPUTS: '/admin/prinputs',
}
class PRInputsApi extends ApiBase {
    async findAll() {
        const response = await this._getRequest<GetPrInputListRequest>(PR_INPUTS_API_PATHS.PR_INPUTS)

        return response
    }

    async archive(pr: { id: string }) {
        const response = await this._patchRequest<PatchPrInputRequest>(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/archive',
            null,
            { prId: pr.id },
        )

        return response
    }

    async unArchive(pr: PRInputListItem) {
        const response = await this._patchRequest<PatchPrInputRequest>(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/unarchive',
            null,
            { prId: pr.id },
        )

        return response
    }
}

export default PRInputsApi
